//USER_PROFILE_FOR_OTHERS
export const USER_PROFILE_FOR_OTHERS_REQUEST = "USER_PROFILE_FOR_OTHERS_REQUEST";
export const USER_PROFILE_FOR_OTHERS_RECEIVE = "USER_PROFILE_FOR_OTHERS_RECEIVE";
export const USER_PROFILE_FOR_OTHERS_FAILURE = "USER_PROFILE_FOR_OTHERS_FAILURE";
export const RESET_USER_PROFILE_FOR_OTHERS= "RESET_USER_PROFILE_FOR_OTHERS";

//FOLLOWING_LIST_FOR_OTHERS
export const FOLLOWING_LIST_FOR_OTHERS_REQUEST = "FOLLOWING_LIST_FOR_OTHERS_REQUEST";
export const FOLLOWING_LIST_FOR_OTHERS_RECEIVE = "FOLLOWING_LIST_FOR_OTHERS_RECEIVE";
export const FOLLOWING_LIST_FOR_OTHERS_FAILURE = "FOLLOWING_LIST_FOR_OTHERS_FAILURE";
export const RESET_FOLLOWING_LIST_FOR_OTHERS= "RESET_FOLLOWING_LIST_FOR_OTHERS";